import SButton from "components/Common/Button"
import DateInput from "components/Common/DateInput"
import SelectBox from "components/Common/SelectBox"
import moment from "moment"
import React, { useState } from "react"
import { Card, CardBody, Col, Input, Row, Table } from "reactstrap"
import { JPYFormat } from "util/currencyFormat"

export default function PaymentForm({ config, payload, itemName }) {
  const [paymentDate, setPaymentDate] = useState("")
  const [paymentAmount, setPaymentAmount] = useState(0)
  const [paymentMethodId, setPaymentMethodId] = useState(0)
  const [paymentSelect, setPaymentSelect] = useState({ label: "", value: 0 })
  const payments = payload[itemName]["payments"]

  const onSelect = e => {
    setPaymentSelect(e)
    setPaymentMethodId(+e.value)
  }

  const resetForm = () => {
    setPaymentDate("")
    setPaymentAmount(0)
    setPaymentMethodId(0)
    setPaymentSelect({ label: "", value: "" })
  }

  const addPayment = () => {
    if (!paymentDate || !paymentMethodId || !paymentAmount) {
      return
    }
    const id = null
    const obj = {
      id,
      paymentDate,
      paymentMethodId,
      paymentMethodName: config.paymentMethods.find(
        meth => meth.value === paymentMethodId
      ).label,
      amount: paymentAmount,
    }
    config.handleInput({ data: obj, type: "payments", itemName })
    /**
     * I like to play it safe, having a waiting time of 1ms is just enough to make sure
     * states are reset to their default value only after they are sent to parent component
     */
    setTimeout(resetForm, 1)
  }
  return (
    <Card>
      <CardBody>
        <div className="px-2 mb-4">
          <Row className="my-2">
            <Col sm={3}>日付</Col>
            <Col sm={5}>
              <DateInput
                className="form-control"
                onChange={([val]) =>
                  setPaymentDate(moment(val).format("YYYY-MM-DD"))
                }
                value={paymentDate}
              />
            </Col>
          </Row>
          <Row className="my-2">
            <Col sm={3}>入金方法</Col>
            <Col sm={5}>
              <SelectBox
                options={config.paymentMethods}
                onChange={onSelect}
                value={paymentSelect}
              />
            </Col>
          </Row>
          <Row className="my-2">
            <Col sm={3}>入金金額</Col>
            <Col sm={5}>
              <Input
                type="number"
                className="form-control"
                onChange={({ target: { value } }) => setPaymentAmount(+value)}
                value={paymentAmount || ""}
              />
            </Col>
            <Col sm={4}>
              <SButton
                style={{ width: "100%" }}
                className="button"
                onClick={addPayment}
              >
                登録
              </SButton>
            </Col>
          </Row>
        </div>
        <Table bordered>
          <thead>
            <tr>
              <th>日付</th>
              <th>入金方法</th>
              <th>金額</th>
            </tr>
          </thead>
          <tbody>
            {payments.length ? (
              payments.map((payment, i) => (
                <tr key={i}>
                  <td>{payment.paymentDate}</td>
                  <td>{payment.paymentMethodName}</td>
                  <td>{JPYFormat(payment.amount)}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            )}
          </tbody>
        </Table>
      </CardBody>
    </Card>
  )
}
